// Cell style mapping constants
export const CELL_STYLE_MAP: Record<string, string> = {
  claimed: 'text-green-600 font-medium',
  settled: 'text-green-600 font-medium',
  outstanding: 'text-orange-500 font-medium',
  awaitingSettlement: 'text-orange-500 font-medium',
  exceptions: 'text-red-600 font-medium',
  default: 'text-green-600 font-medium',
};

// Row depth style mapping
export const ROW_DEPTH_STYLES: Record<string, string> = {
  '0': 'text-sm text-base font-semibold text-primary dark:text-primary-300',
  '1': 'text-sm font-semibold text-slate-800',
  '2': 'text-sm font-semibold text-slate-700',
  '3': 'text-xs font-semibold text-slate-600',
  'default': 'text-xs bg-white text-slate-500',
};

// Node type to icon display mapping
export const NODE_TYPE_DISPLAY = {
  BRAND: 'Brand',
  DRIVER: 'Driver',
  ROUTE: 'Route',
  CUSTOMER: 'Customer',
} as const;

// Header class names mapping
export const HEADER_CLASS_NAMES: Record<string, string> = {
  outstanding: 'bg-red-100 text-xs',
  exceptions: 'bg-red-100 text-xs',
  cumOutstanding: 'bg-red-100 text-xs',
  cumExceptions: 'bg-red-100 text-xs',
  settlementCumAwaiting: 'bg-blue-100 text-xs',
  awaitingSettlement: 'bg-blue-100 text-xs',
  settlementExceptions: 'bg-blue-100 text-xs',
  settlementCumExceptions: 'bg-blue-100 text-xs',
  recorded: 'bg-red-100 text-sm',
  verified: 'bg-red-100 text-sm',
  claimed: 'bg-blue-100 text-sm',
  settled: 'bg-blue-100 text-sm',
  topic: 'bg-slate-200 border-r-slate-300 opacity-80',
  default: 'bg-white',
};

// Cumulative loading cells
export const CUMULATIVE_LOADING_CELLS = [
  'cumOutstanding',
  'cumExceptions',
  'settlementCumAwaiting',
  'settlementCumExceptions',
];

// Filter tag mapping
export const FILTER_TAG_MAP: Record<string, string> = {
  TERMINAL: 'TERMINAL',
  DRIVER: 'DRIVER',
  PAYMENT_METHOD: 'PAYMENT_METHOD',
  ROUTE: 'ROUTE',
};

// Initial visible rows count
export const INITIAL_VISIBLE_ROWS = 50;

// Load more rows increment
export const LOAD_MORE_INCREMENT = 50;

// Expansion animation delay
export const EXPANSION_DELAY = 100;

// Load more animation delay
export const LOAD_MORE_DELAY = 300;
